import { create } from 'zustand';

type AppFilterModalStore = {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
};

/**
 * Simple Zustand store for the app filter modal actions.
 * Used this to open and close the app filter modal from anywhere in the app.
 */
export const useAppFilterModalStore = create<AppFilterModalStore>((set) => ({
  isOpen: false,
  openModal: () => set({ isOpen: true }),
  closeModal: () => set({ isOpen: false })
}));
